
import { useEffect } from 'react';

interface StructuredDataProps {
  data: any;
  id?: string;
}

const StructuredData = ({ data, id = 'structured-data' }: StructuredDataProps) => {
  useEffect(() => {
    // Handle cases where data is missing: remove any existing script and exit
    const existingScript = document.getElementById(id);
    if (!data) {
      if (existingScript) existingScript.remove();
      return;
    }

    // Remove existing structured data with the same ID before injecting new
    if (existingScript) {
      existingScript.remove();
    }

    // Create and append new structured data
    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      const scriptToRemove = document.getElementById(id);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [data, id]);

  return null;
};

export default StructuredData;
